import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onGetGraduatedCvByUser,
  onGetGraduatedCoverLetterByUser,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import {
  onCreateGraduatedJobApplication,
  oncreateJobApplicationState,
  onDeleteGraduatedJobApplication,
  onGetGraduatedJobApplication,
  onGetGraduatedJobsApplication,
  onGetKVKKGraduatedJobApplication,
  onGetPagedAllJobApplicationsForAdmin,
  onGetPagedAllJobApplicationsForCompanies,
} from '../../../app/modules/areas/graduates/jobs/core/_requests'
import GetGraduatedJobApplication from '../../../app/modules/areas/graduates/my-applications/core/dto/GetGraduatedJobApplication'
import Codes from '../../../app/modules/base-definitions/components/code/PredefinedCodes'
interface ApplicationState {
  cvs: any
  coverLetters: any
  kvkk: string
  isLoading: boolean,
  graduatedJobApplication:any,
  allGraduatedJobsApplication:any,
  allJobApplicationForCompany:any,
  allJobApplicationForAdmin:any
}
const initialState = {
  cvs: [],
  coverLetters: [],
  kvkk: '',
  isLoading: true,
} as ApplicationState

export const fetchKVKK = createAsyncThunk('graduatedJobApplication/fetchKVKK', async (param :any) => {
  const data: any = await onGetKVKKGraduatedJobApplication(param)
  return data.data.result
})

export const fetchCv = createAsyncThunk('graduatedJobApplication/fetchCv', async () => {
  const data: any = await onGetGraduatedCvByUser()
  return data.data.result
})

export const fetchCoverLetter = createAsyncThunk(
  'graduatedJobApplication/fetchCoverLetter',
  async () => {
    const data: any = await onGetGraduatedCoverLetterByUser()
    return data.data.result
  }
)
export const createGraduatedJobApplication = createAsyncThunk(
  'graduatedJobApplication/createGraduatedJobApplication',
  async (param: any) => {
    const data: any = await onCreateGraduatedJobApplication(param)

    return data.data.result
  }
)
export const fetchGraduatedJobsApplication = createAsyncThunk(
  'graduatedJobApplication/fetchGraduatedJobsApplication',
  async (param: any) => {
    const data: any = await onGetGraduatedJobsApplication(param)
    return data.data.result
  }
)
export const fetchGraduatedJobApplication = createAsyncThunk(
  'graduatedJobApplication/fetchGraduatedJobApplication',
  async (param: any) => {
    const data: any = await onGetGraduatedJobApplication(param)
    //debugger
    return data.data.result
  }
)
export const fetchJobApplicationForCompany = createAsyncThunk(
  'graduatedJobApplication/fetchGraduatedJobApplicationForCompany',
  async (param: any) => {
    const data: any = await onGetPagedAllJobApplicationsForCompanies(param)
    //debugger
    return data.data.result
  }
)
export const fetchJobApplicationForAdmin = createAsyncThunk(
  'graduatedJobApplication/fetchGraduatedJobApplicationForAdmin',
  async (param: any) => {
    const data: any = await onGetPagedAllJobApplicationsForAdmin(param)
    //debugger
    return data.data.result
  }
)
export const deleteGraduatedJobApplication = createAsyncThunk(
  'graduatedJobApplication/deleteGraduatedJobApplication',
  async (param: any) => {
    const data: any = await onDeleteGraduatedJobApplication(param)
    return data.data
  }
)

export const createJobApplicationState = createAsyncThunk(
  'graduatedJobApplication/createJobApplicaitonState',
  async (param: any) => {
    const data: any = await oncreateJobApplicationState(param)
    return data.data
  }
)

const graduatedJobApplicationSlice = createSlice({
  name: 'graduatedJobApplication',
  initialState,
  reducers: {
    clearAllGraduatedJobApplication: (state) => {
      state.allGraduatedJobsApplication = []
    },
    clearAllJobApplicationForCompany: (state) => {
      state.allJobApplicationForCompany = []
    },
    clearGraduatedJobApplication: (state) => {
      state.graduatedJobApplication = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCv.fulfilled, (state: any, action) => {
      state.cvs = action.payload.items
    })
    builder.addCase(fetchCoverLetter.fulfilled, (state: any, action) => {
      state.coverLetters = action.payload.items
    })
    builder.addCase(fetchKVKK.fulfilled, (state: any, action) => {
      state.kvkkContent = action.payload?.body ? action.payload.body : ''
    })
    
    builder.addCase(fetchGraduatedJobsApplication.pending, (state: any, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedJobsApplication.fulfilled, (state: any, action) => {
      state.allGraduatedJobsApplication = action.payload;
      state.isLoading = false
    })
    builder.addCase(fetchGraduatedJobApplication.pending, (state: any, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchGraduatedJobApplication.fulfilled, (state: any, action) => {
      state.graduatedJobApplication = action.payload;
      state.isLoading = false
    })

    builder.addCase(fetchJobApplicationForCompany.pending, (state: any, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchJobApplicationForCompany.fulfilled, (state: any, action) => {
      state.allJobApplicationForCompany = action.payload;
      state.isLoading = false
    })

    builder.addCase(fetchJobApplicationForAdmin.pending, (state: any, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchJobApplicationForAdmin.fulfilled, (state: any, action) => {
      state.allJobApplicationForAdmin = action.payload;
      state.isLoading = false
    })
  },
})

export const {clearAllGraduatedJobApplication, clearGraduatedJobApplication, activateLoading} = graduatedJobApplicationSlice.actions

export default graduatedJobApplicationSlice.reducer
